(() => {
  const create = (options) => {
    if (!options.type) {
      window.console.error('A widget was programmatically initialized without setting the type property');
    }

    const uuid = Date.now();

    options.initialState = { timestamp: (new Date()).getTime(), ...options.initialState };

    const widget = document.createElement('span');

    widget.classList.add('swinger-widget');
    widget.classList.add('swinger-widget--dynamic');
    widget.classList.add(`swinger-widget--${options.type}`);
    widget.setAttribute('data-type', options.type);
    widget.setAttribute('data-id', `${options.type}-${uuid}`);

    if (options.initialState) {
      window.swinger = window.swinger || {};
      window.swinger.widgets = window.swinger.widgets || {};
      window.swinger.widgets.states = window.swinger.widgets.states || {};
      window.swinger.widgets.states[`${options.type}-${uuid}`] = { ...window.swinger.widgets.states[`${options.type}-${uuid}`], ...options.initialState };

      if (
        window.swinger
        && window.swinger.widgets
        && window.swinger.widgets.stores
        && window.swinger.widgets.stores[`${options.type}-${uuid}`]) {
        window.swinger.widgets.stores[`${options.type}-${uuid}`].dispatch({
          type: 'REPLACE_STATE',
          value: options.initialState,
        });
      }
    }

    return widget;
  };

  const prepend = (options, target) => {
    const widget = create(options);
    const targetParent = target.parentNode;

    if (widget && target && targetParent) {
      targetParent.insertBefore(widget, target);
    }

    return widget;
  };

  const replace = (options, target) => {
    const widget = create(options);
    const targetParent = target.parentNode;

    if (widget && target && targetParent) {
      targetParent.replaceChild(widget, target);
    }

    return widget;
  };

  window.swinger = {
    ...window.swinger,
    widgets: {
      create,
      prepend,
      replace,
      states: {

        ...window.swinger && window.swinger.widgets && window.swinger.widgets.states,
      },
    },
  };
})();
